import { defineMessages } from 'react-intl';

export default defineMessages({
  maintenance: {
    title: {
      id: 'maintenance.title',
      defaultMessage: 'Kami akan segera kembali',
    },
    description: {
      id: 'maintenance.description',
      defaultMessage:
        'Layanan ini sedang dalam perbaikan. Jangan khawatir, kami sedang melakukan yang terbaik dan akan segera kembali!',
    },
    btn: {
      id: 'maintenance.btn',
      defaultMessage: 'KEMBALI KE HALAMAN UTAMA',
    },
  },
  unauthorized: {
    title: {
      id: 'error.unauthorized.title',
      defaultMessage: 'Sesi Kadaluarsa',
    },
    description: {
      id: 'error.unauthorized.description',
      defaultMessage:
        'Sesi kamu kadaluarsa. Coba lagi dengan menekan tombol kembali.',
    },
    btn: {
      id: 'error.unauthorized.btn',
      defaultMessage: 'KEMBALI',
    },
  },
});
